import React, { useEffect } from "react";
import { useLocalStore, useStoreActions } from "easy-peasy";
import { useHistory } from "react-router";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import BreadCrumbs from "components/admin_v2/common/BreadCrumbs";
import Spinner from "components/admin_v2/ui/Spinner";
import { OutlinedBtn } from "components/admin_v2/ui/Buttons";
import TopPageLayout from "components/admin_v2/nav/TopPageLayout";
import SettingsConfigTabs from "components/admin_v2/settings_config/SettingsConfigTabs";
import I18n from "utils/i18n.js";
import { PrimaryBtn } from "components/admin_v2/ui/Buttons";
import ProgramForm from "./ProgramForm";
import { programsStore } from "components/admin_v2/settings_config/stores/programsStore";
import { pageRoutes } from "services/api";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";

const ProgramEdit = (props) => {
  const id = props.match.params.id;
  const cls = useCommonPageStyles();
  const history = useHistory();
  const { setFlashMessage } = useStoreActions((s) => s.app);
  const store = useLocalStore(() => programsStore());
  const [state, actions] = store;
  const { program } = state;

  useEffect(() => {
    if (!id) return;

    actions.fetchProgram(id);
  }, [id]);

  const onSubmit = () => {
    actions.save().then((r) => {
      setFlashMessage({ message: r.message });
      history.push(pageRoutes.program(r.program.id));
    });
  };

  return (
    <React.Fragment>
      <TopPageLayout title={I18n.t("settings_config.title")} />
      <SettingsConfigTabs />
      <BreadCrumbs
        path={pageRoutes.programs()}
        label={I18n.t("settings_config.programs.breadcrumb")}
      />
      <Box className={cls.titleWithBtn}>
        <Typography variant="h1" gutterBottom>
          {program?.name}
        </Typography>
        <Box className={cls.btnsWrapper}>
          <OutlinedBtn className={`${cls.actionBtn} active`} disabled>
            {I18n.t("settings_config.edit_program.btn")}
          </OutlinedBtn>
          <OutlinedBtn className={cls.actionBtn} onClick={() => actions.toggleArchive(id)}>
            {program?.discarded ? I18n.t("ui.btn.unarchive") : I18n.t("ui.btn.archive")}
          </OutlinedBtn>
        </Box>
      </Box>
      <Paper className={cls.paper}>
        {state.loading ? (
          <Spinner />
        ) : (
          <>
            <ProgramForm store={store} onSubmit={onSubmit} />{" "}
            <PrimaryBtn onClick={onSubmit} disabled={!state.isValid}>
              {I18n.t("settings_config.programs.form.save")}
            </PrimaryBtn>
          </>
        )}
      </Paper>
    </React.Fragment>
  );
};

export default ProgramEdit;
